<template>
  <v-container>
    <v-row align="center" dense>
      <v-col
        v-for="(link, i) in links"
        :key="i"
        class="text-center hidden-sm-and-down"
        cols="6"
        md="auto"
      >
        <a
          :href="link.href"
          class="text-decoration-none text-uppercase text-caption font-weight-regular"
          rel="noopener"
          target="_blank"
          v-text="link.text"
        />
      </v-col>

      <v-col
        v-if="barionModuleOn"
        cols="12"
        md="auto"
      >
        <a
          href="https://www.barion.com"
          target="_blank"
        >
          <v-img
            :src="require('@/assets/barion/barion-card-strip-intl__small.png')"
          />
        </a>
      </v-col>

      <v-spacer class="hidden-sm-and-down" />

      <v-col
        v-if="profile.user_id === 87"
        cols="12"
        md="auto"
        class="text-center"
      >
        Last build: {{ build_date | dateTimeFormat }}
      </v-col>

      <v-col
        cols="12"
        md="auto"
        class="text-center"
      >
        <v-btn
          class="ma-2"
          text
          @click="getReport({ type: 'help-pdf'})"
        >
          {{ $t('manual') }}
        </v-btn>
      </v-col>

      <v-col
        v-if="barionModuleOn"
        cols="12"
        md="auto"
        class="text-center"
      >
        <aszf
          title="aszf"
          color="auto"
        />
      </v-col>

      <v-col
        cols="12"
        md="auto"
        class="text-center"
      >
        <preambulum-informations
          title="privacy_statement"
          color="auto"
        />
      </v-col>

      <v-col
        cols="12"
        md="auto"
        class="text-center hidden-sm-and-down"
      >
        <div class="text-body-1 font-weight-light pt-0 pt-md-0 text-center">
          &copy; {{ (new Date()).getFullYear() }}, Made by <v-icon>mdi-vuetify</v-icon>
          <a
            href="https://vuetifyjs.com/en/about/meet-the-team/#company"
            class="text-decoration-none"
          >Vuetify</a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PreambulumInformations from '@/layouts/default/infos/PreambulumInfo'
  import Aszf from '@/layouts/default/infos/Aszf'
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'Links',
    components: { Aszf, PreambulumInformations },
    data: () => ({
      build_date: document.documentElement.dataset.buildTimestampUtc,
      links: [
        /* {
          href: 'https://vuetifyjs.com/',
          text: 'Vuetify Docs',
        },
        {
          href: '#',
          text: 'About Us',
        },
        {
          href: '#',
          text: 'Blog',
        },
        {
          href: '#',
          text: 'Licenses',
        }, */
      ],
    }),
    computed: {
      profile: get('auth/profile'),
      barionModuleOn () { return this.profile.organization.modules.filter(m => m.name === 'barion').length > 0 || this.profile.user_id === 4 },
    },
    methods: {
      getReport: call('action/getReport'),
    },
  }
</script>

<style lang="sass" scoped>
  a
    color: inherit !important
</style>
